import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=c51b91be&scoped=true&"
import script from "./messageList.vue?vue&type=script&lang=js&"
export * from "./messageList.vue?vue&type=script&lang=js&"
import style0 from "./messageList.vue?vue&type=style&index=0&id=c51b91be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51b91be",
  null
  
)

export default component.exports